import { HANDLE_ALERT_LOG, RESET } from '../actions';

const initialState = {
    deviceData: [],
    deviceList: [],
    deviceListAPICalled: false,
    selectedDevice: "",
    selectedIMEI: "",
    selectedPowerMeter: "",

    skip: 0,
    limit: 50,
    alertLog: []
};

const DeviceData = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_ALERT_LOG:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default DeviceData;